/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import PulseLoader from 'react-spinners/PulseLoader';

interface ProgressIndicatorProps {
  color?: string,
  size?: number,
  margin?: string,
  align?: string,
  className?: string
  style?: object
};

/**
 * Defines the default configurations applied to the loader.
 * @see https://github.com/yuanyan/halogen
 */
const defaults = {
  color  : '#00d8ff',
  size   : 8,
  margin : '0 4px',
  align  : 'left'
};
/**
 * Provides a reusable indeterminate Progress indicator which is
 * intended to convery asyncronous progress status within the
 * application.
 */
const ProgressIndicator = ({
  color = defaults.color,
  size = defaults.size,
  margin = defaults.margin,
  align = defaults.align,
  className,
  style
}: ProgressIndicatorProps) => {
  return (
    <PulseLoader className={className}
      style={style}
      color={color}
      size={size}
      margin={margin}
      alignItems={align}/>
  );
};

export default ProgressIndicator;
